import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../scss/privacy-policy.style.scss';
import { ContactCard } from './contact-card.component';
import { useNavigate } from 'react-router-dom';
import { LOCALES } from '../../common/constants';
import { howItWorksImages, uiIcons } from '../constant/how-it-works-sections.constant';
import { dpoContacts, personalDataControllerContacts, privacyPolicySections } from '../constant/privacy-policy-constant';

interface ContactInfo {
    icon: string;
    title: string;
    value: string;
}

const PrivacyPolicyComponent: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const language = localStorage.getItem("i18nextLng");

    const handleCreateAccount = () => {
        navigate(
            language === LOCALES.EN_US
                ? `/emailregister?lang=${LOCALES.EN_US}`
                : `/e-postregister?lang=${LOCALES.SV_SE}`
        );
    };

    return (
        <div className="privacy-policy-page px-0">
            {/* Main content sections */}
            {privacyPolicySections.map((section, index) => (
                <section key={index} className="privacy-section px-0 mb-3">
                    <Container>
                        <Row className="align-items-start">
                            <Col lg={6} md={12} className="px-0 mb-0 mb-lg-0">
                                <h2 className="section-heading">
                                    {t(section.title)}
                                </h2>
                            </Col>
                            <Col lg={6} md={12} className="px-0">
                                <div className="section-content">
                                    <p>{t(section.content)}</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            ))}

            {/* Data Protection Officer & Cookies Section */}
            <section className="privacy-section data-protection-section px-0 mb-5">
                <Container>
                    <Row className="align-items-start">
                        <Col lg={6} md={12} className="px-0 mb-4 mb-lg-0">
                            <h2 className="section-heading">
                                {t('PRIVACY_POLICY_DATA_PROTECTION_COOKIES')}
                            </h2>
                        </Col>
                        <Col lg={6} md={12} className="px-0">
                            <div className="contact-sections">
                                {/* Personal Data Controller Section */}
                                <div className="contact-group mb-5">
                                    <h4 className="contact-group-title mb-3">
                                        {t('PRIVACY_POLICY_AT_CONTROLLER')}:
                                    </h4>
                                    <p className="contact-group-description mb-4">
                                        {t('PRIVACY_POLICY_CONTACT_CONTROLLER')}
                                    </p>
                                    <div className="contact-cards">
                                        {personalDataControllerContacts.map((contact, index) => (
                                            <ContactCard
                                                key={index}
                                                icon={contact.icon}
                                                title={contact.title}
                                                value={contact.value}
                                            />
                                        ))}
                                    </div>
                                </div>

                                {/* Data Protection Officer Section */}
                                <div className="contact-group mb-5">
                                    <h4 className="contact-group-title mb-3">
                                        {t('PRIVACY_POLICY_DATA_PROTECTION_OFFICER')}
                                    </h4>
                                    <p className="contact-group-description mb-4">
                                        {t('PRIVACY_POLICY_DPO_DESCRIPTION')}
                                    </p>
                                    <div className="contact-cards">
                                        {dpoContacts.map((contact, index) => (
                                            <ContactCard
                                                key={index}
                                                icon={contact.icon}
                                                title={contact.title}
                                                value={contact.value}
                                            />
                                        ))}
                                    </div>
                                </div>

                                {/* Cookies Description */}
                                <div className="cookies-description">
                                    <p>{t('PRIVACY_POLICY_COOKIES_DESCRIPTION')}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="cta-section">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={7} xl={7} className="cta-content">
                            <div className="cta-text">
                                <h2 className="cta-title">
                                    {t('Ready to Get Started?')}
                                </h2>
                                <p className="cta-description">
                                    {t('Join thousands of freelancers using Invozio to invoice without a company. It\'s fast, secure, and completely free to create an account.')}
                                </p>
                            </div>
                            <button className="cta-button" onClick={handleCreateAccount}>
                                <span className="cta-btn-text">
                                    {t('Create Free Account')}
                                </span>
                                <img
                                    src={uiIcons.rightArrow}
                                    alt="Right Arrow"
                                    className="cta-arrow-icon"
                                />
                            </button>
                        </Col>
                        <Col lg={5} xl={5} className="cta-image-col d-none d-lg-block">
                            <div className="cta-image-container">
                                <img
                                    src={howItWorksImages.ctaBackground}
                                    alt="Get Started"
                                    className="cta-background-privacy"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default PrivacyPolicyComponent;
